import styled from "styled-components";

export const DownSidebarStyled = styled.div`
  .down-sidebar__chat-block {
    padding-bottom: 0;
  }
  .simplebar-custom {
    height: calc(100% + 10px);
    margin: -10px -15px;
    padding: 10px 15px;
  }
  
  .delete-comment {
    font-size: 20px;
    color: #aaa;
    margin-right: 15px;
    background: transparent;
    border: none;
  }
  
  .down-sidebar__chat-item--answer svg {
    display: block;
  }
`
